import { ChangeDetectionStrategy, Component, inject, Input, output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { TranslatePipe } from '@core/i18n-legacy';

import { AvatarComponent } from '../avatar/avatar.component';
import { DropdownHeaderComponent } from '../dropdown/dropdown-header/dropdown-header.component';
import { DropdownItemComponent } from '../dropdown/dropdown-item/dropdown-item.component';
import { DropdownComponent } from '../dropdown/dropdown.component';
import { HeadingComponent } from '../heading/heading.component';
import { IconComponent } from '../icon/icon.component';
import { TruncateComponent } from '../truncate/truncate.component';

@Component({
  selector: 'rt-mail-picker',
  templateUrl: './mail-picker.component.html',
  styleUrls: ['./mail-picker.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AvatarComponent,
    DropdownComponent,
    DropdownHeaderComponent,
    DropdownItemComponent,
    HeadingComponent,
    IconComponent,
    TranslatePipe,
    TruncateComponent,
  ],
})

// TODO: This component should not be the part of UI lib
export class MailPickerComponent {
  private readonly route = inject(ActivatedRoute);

  @Input() public index: number;
  @Input() public tag: {
    candidateId?: number;
    candidate?: {
      id: number;
      photoThumbUrl: string;
      name: string;
      placements: Array<{ offer: { title: string } }>;
      emails: string[];
      initials: string;
      hasAvatar: boolean;
    };
    adminId?: number;
    admin?: {
      photoThumbUrl: string;
      initials: string;
      hasAvatar: boolean;
    };
    email: string;
    emailsFromThread?: string[];
    name: string;
  };
  @Input() public selectCandidate: boolean = false;

  public openCandidate = output<{
    id: number;
  }>();
  public emailSelect = output<{
    index: number;
    email: string;
  }>();

  protected isOnCandidateProfile = !!this.route.snapshot.queryParams?.['candidate'];

  public isCandidate(): boolean {
    return !!this.tag.candidateId || this.selectCandidate;
  }

  public getAllEmailsFromTag() {
    return this.tag.emailsFromThread ? this.tag.emailsFromThread : this.tag.candidate!.emails;
  }

  public isAdmin(): boolean {
    return !!this.tag.adminId && !this.selectCandidate;
  }

  public showCandidate(): void {
    if (this.tag.candidate) {
      this.openCandidate.emit(this.tag.candidate);
    }
  }

  public isEmailActive(email: string): boolean {
    return this.tag.email === email;
  }

  public select(email: string): void {
    this.emailSelect.emit({
      index: this.index,
      email: email,
    });
  }

  public trackByEmail(index: number, email: string): string {
    return email;
  }
}
